import { t as e } from "../../utils-C1uyTI6x.js";
import { t } from "../../constants-B7fXbm2f.js";
import { t as n } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as r, createElementVNode as i, normalizeClass as a, openBlock as o } from "vue";
//#region ../src/icons/freshdesk.vue
var s = {
	name: "DtIconFreshdesk",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (e) => Object.keys(t).includes(e)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return t[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded"), this.uniqueID = e();
	}
}, c = [
	"aria-label",
	"data-qa",
	"aria-hidden"
], l = ["clip-path"], u = ["id"];
function d(e, t, n, s, d, f) {
	return o(), r("svg", {
		"aria-label": n.ariaLabel,
		class: a([f.iconSizeClass, "d-icon d-icon--freshdesk"]),
		"data-qa": f.dataQA,
		"aria-hidden": f.ariaHidden,
		role: "img",
		"data-name": "Freshdesk",
		viewBox: "0 0 24 24",
		xmlns: "http://www.w3.org/2000/svg"
	}, [i("g", { "clip-path": `url(#${e.uniqueID}a)` }, [...t[0] || (t[0] = [i("path", {
		d: "M20.976 0A3.002 3.002 0 0 1 24 3.027v9.011C24 18.646 18.645 24 12.037 24h-.068A11.959 11.959 0 0 1 0 12.041C0 5.414 5.346.068 11.963.001h9.013Zm-9.022 5.35a5.486 5.486 0 0 0-5.487 5.492v3.736c.021 1 .827 1.807 1.827 1.828h1.554v-4.293h-2.1v-1.199a4.27 4.27 0 0 1 4.262-4.028 4.263 4.263 0 0 1 4.256 4.028v1.2h-2.13v4.295h1.405v.069a1.713 1.713 0 0 1-1.688 1.687h-1.677c-.137 0-.286.068-.286.204a.301.301 0 0 0 .286.286h1.687a2.195 2.195 0 0 0 2.182-2.181v-.137a1.8 1.8 0 0 0 1.404-1.772v-3.94c-.085-2.959-2.483-5.275-5.495-5.275Z",
		fill: "#25C16F"
	}, null, -1), i("path", {
		d: "M11.955 5.349a5.486 5.486 0 0 0-5.487 5.492v3.736c.021 1 .827 1.807 1.827 1.828h1.554v-4.293h-2.1v-1.199a4.27 4.27 0 0 1 4.262-4.028 4.263 4.263 0 0 1 4.256 4.028v1.2h-2.13v4.295h1.405v.069a1.713 1.713 0 0 1-1.688 1.687h-1.677c-.137 0-.286.068-.286.204a.301.301 0 0 0 .286.286h1.687a2.195 2.195 0 0 0 2.182-2.181v-.137a1.8 1.8 0 0 0 1.404-1.772v-3.94c-.085-2.959-2.483-5.275-5.495-5.275Z",
		fill: "#fff"
	}, null, -1)])], 8, l), i("defs", null, [i("clipPath", { id: `${e.uniqueID}a` }, [...t[1] || (t[1] = [i("path", {
		fill: "#fff",
		d: "M0 0h24v24H0z"
	}, null, -1)])], 8, u)])], 10, c);
}
var f = /* @__PURE__ */ n(s, [["render", d]]);
//#endregion
export { f as default };

//# sourceMappingURL=freshdesk.js.map